import { useState, useCallback, useEffect } from 'react';
import { SelectItemProps, Response } from '@ui/src';
import { Account } from '../../accounts/types';
import { useLazyGetAccountsForExternalQuery } from '../store/services';

interface ListResponse {
  data: Response<Account>;
}

let timeout: NodeJS.Timeout;

const useGetAccountsAutocompleteList = (query?: string, accountId?: string) => {
  const [autocompleteList, setAutocompleteList] = useState<SelectItemProps[]>(
    [],
  );

  const [getList, { isFetching, isLoading }] =
    useLazyGetAccountsForExternalQuery();

  const getAutocompleteListAction = useCallback(
    async (search?: string) => {
      const results: SelectItemProps[] = [];
      const accounts: Account[] = [];

      const response = (await getList(
        `take=40&sortProp=fullNumber&sortDir=asc${
          search ? `&search=${search}` : ''
        }${query || ''}`,
      )) as ListResponse;

      if (response?.data?.data) {
        response.data.data.edges?.forEach((item) => {
          results.push({
            name: item.node.description,
            description: '',
            value: item.node.id,
            suffix: item.node.fullNumber,
          });

          accounts.push(item.node);
        });
      }

      setAutocompleteList(results);
    },
    [query],
  );

  const onSearch = (search: string) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      getAutocompleteListAction(search);
    }, 300);
  };

  const onClear = () => {
    getAutocompleteListAction();
  };

  useEffect(() => {
    if (!accountId) {
      getAutocompleteListAction();
    }
  }, [getAutocompleteListAction, accountId]);

  return {
    getAutocompleteListAction,
    autocompleteList,
    onSearch,
    isLoading: isLoading || isFetching,
    onClear,
  };
};

export default useGetAccountsAutocompleteList;
